/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdentitySourceName } from './IdentitySourceName';
import {
    IdentitySourceNameFromJSON,
    IdentitySourceNameFromJSONTyped,
    IdentitySourceNameToJSON,
    IdentitySourceNameToJSONTyped,
} from './IdentitySourceName';

/**
 * 
 * @export
 * @interface AccessRequestAppExternalConnection
 */
export interface AccessRequestAppExternalConnection {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestAppExternalConnection
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestAppExternalConnection
     */
    name?: string;
    /**
     * 
     * @type {IdentitySourceName}
     * @memberof AccessRequestAppExternalConnection
     */
    source: IdentitySourceName;
}



/**
 * Check if a given object implements the AccessRequestAppExternalConnection interface.
 */
export function instanceOfAccessRequestAppExternalConnection(value: object): value is AccessRequestAppExternalConnection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function AccessRequestAppExternalConnectionFromJSON(json: any): AccessRequestAppExternalConnection {
    return AccessRequestAppExternalConnectionFromJSONTyped(json, false);
}

export function AccessRequestAppExternalConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestAppExternalConnection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'source': IdentitySourceNameFromJSON(json['source']),
    };
}

export function AccessRequestAppExternalConnectionToJSON(json: any): AccessRequestAppExternalConnection {
    return AccessRequestAppExternalConnectionToJSONTyped(json, false);
}

export function AccessRequestAppExternalConnectionToJSONTyped(value?: AccessRequestAppExternalConnection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': IdentitySourceNameToJSON(value['source']),
    };
}

